import { ProjectSortInfo } from '~/api/repository'
import sort = ProjectSortInfo.sort;

export class EcosystemSortModel {
  private readonly _value?: string
  private readonly _label?: string

  private _sortLabel = {
    [sort.RECENT]: 'Latest',
    [sort.ALPHABETICAL]: 'A-Z',
  }

  constructor (res: ProjectSortInfo) {
    this._value = res.sort
    this._label = res.sort && this._sortLabel[res.sort]
  }

  get value () {
    return this._value
  }

  get label () {
    return this._label
  }
}